import { useEffect } from 'react';
import { useLocation } from 'react-router';

/**
 * Reseta o scroll para o topo sempre que a rota muda.
 * Deve ser renderizado dentro do BrowserRouter, antes das rotas.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
}
